import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  setLocationState
} from 'store/redux/heartbeats'

export default function * fetchHeartbeats (action) {
  const { location } = action.payload

  const state = yield select()

  if (
    !state.kanbo.config.heartbeats ||
    !state.kanbo.config.heartbeats.UserStateTracking
  ) return

  const { State } = yield call(apiGetData, 'HeartbeatState', { location })

  yield put(setLocationState({
    location,
    state: State.map(({ UserId, Action }) => ({
      location,
      userId: UserId,
      action: Action
    }))
  }))
}
